module.exports = __webpack_public_path__ + "img/bh.736ec7e1.svg";